const ChallengeList = ({ children }) => (
  <ul className="list-unstyled">{children}</ul>
);

export default ChallengeList;
